import { render, staticRenderFns } from "./selects.vue?vue&type=template&id=08c48cae&"
import script from "./selects.vue?vue&type=script&lang=ts&"
export * from "./selects.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports